// Entry da aba "Comercial → Propostas". Após refactor topológico (2026-05-23),
// cada aba (Propostas, Vendas, Catálogo, Modelos) virou um sub-componente em
// ./comercial-propostas/.
//
// IMPORTANTE: `ViewerProposta` continua exportada daqui (re-export) porque é
// importada externamente por NegocioDetalhe.tsx e HydraDrawer.tsx.
import { useState } from 'react';
import { Tabs, App as AntApp } from 'antd';
import { CatalogoServicos } from './comercial-propostas/CatalogoServicos';
import { ListaGeradas } from './comercial-propostas/ListaGeradas';
import { ListaModelos } from './comercial-propostas/ListaModelos';
import { ViewerProposta } from './comercial-propostas/ViewerProposta';

// Re-export pra compatibilidade com imports externos
// (NegocioDetalhe.tsx faz `import { ViewerProposta } from './ComercialPropostas';`)
export { ViewerProposta };

export default function ComercialPropostas() {
  const [aba, setAba] = useState<'propostas' | 'vendas' | 'modelos' | 'catalogo'>('propostas');
  return (
    <AntApp>
      <div style={{ maxWidth: 1300, margin: '16px auto', padding: '0 24px' }}>
        <Tabs activeKey={aba} onChange={(k) => setAba(k as any)} size="small"
          items={[
            { key: 'propostas', label: '📄 Propostas', children: aba === 'propostas' ? <ListaGeradas tipo="proposta" /> : null },
            { key: 'vendas', label: '💰 Vendas', children: aba === 'vendas' ? <ListaGeradas tipo="venda" /> : null },
            { key: 'catalogo', label: '🛠️ Catálogo de serviços', children: aba === 'catalogo' ? <CatalogoServicos /> : null },
            { key: 'modelos', label: '📋 Modelos', children: aba === 'modelos' ? <ListaModelos /> : null },
          ]}
        />
      </div>
    </AntApp>
  );
}
